import { FSQueryRootPath } from 'common/cms/models/FSQuery/constants'
import { FsFolderObject } from 'shared/api/requests/cms/schemas'

export const getChildrenFolders = (folders: FsFolderObject[], path: string) => {
  const pathForSearch = path === FSQueryRootPath ? '' : path
  return folders.filter((folder) => {
    return folder.path === `${pathForSearch}/${folder.folder_id}`
  })
}
